import { DEFAULT_META_DESCRIPTION, SITE_NAME } from './seo'

/** WebSite schema with `/?q=` sitelinks search template. */
export function websiteSearchJsonLd(siteOriginTrimmed: string): Record<string, unknown> {
  const base = siteOriginTrimmed.replace(/\/$/, '')
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    alternateName: 'North Kingstown RI Forum',
    description: DEFAULT_META_DESCRIPTION,
    url: `${base}/`,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${base}/discussions?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  }
}
